import posthog from 'posthog-js';
import { env } from '$env/dynamic/public';
import type { HandleClientError } from '@sveltejs/kit';

export async function init() {
	const token = env.PUBLIC_POSTHOG_PROJECT_TOKEN;
	const host = env.PUBLIC_POSTHOG_HOST;

	if (!token) {
		console.warn('PostHog disabled: PUBLIC_POSTHOG_PROJECT_TOKEN is not set');
		return;
	}

	posthog.init(token, {
		api_host: host,
		ui_host: 'https://us.posthog.com',
		defaults: '2026-01-30',
		capture_exceptions: true
	});
}

export const handleError: HandleClientError = async ({ error, status, message }) => {
	// Only capture if PostHog was initialized
	if (posthog.__loaded) {
		posthog.captureException(error);
	}
	return {
		message,
		status
	};
};
